import { useCreateStateV2CMMutation } from "../../core/api/cloclmaker-state-api"
import {
    useGetSyncConflictCMQuery,
    useGetSyncConflictsCMQuery
} from "../../core/api/cm-sync-conflicts-api"
import SyncConflictsPage from "./SyncConflictsPage"

export default function SyncConflictsCM({ game = "cm" }) {
    const [createState, createStateResult] = useCreateStateV2CMMutation()

    return (
        <SyncConflictsPage
            game={game}
            useListQuery={useGetSyncConflictsCMQuery}
            useDetailQuery={useGetSyncConflictCMQuery}
            createState={createState}
            createStateResult={createStateResult}
        />
    )
}
